import { AttributeList } from './AttributeList';
import { Attribute } from './Attribute';
import { AttributeSet } from './AttributeSet';
import { Prices } from './Prices';

export enum ProductStatus {
  PUBLISHED = '40-GEPUB',
  NOT_PUBLISHED = '45-NI-GE',
  END_OF_LIFE_PRODUCT = '50-EOL',
  END_OF_LIFE_LINE = '99-EOL',
  FREE = '10-VRIJ'
}


export interface Product {
  code: string;
  title: string;
  visible: boolean;
  displayOrder: number;
  description: string;
  mainCategoryId: number;
  relatedProducts: string[];
  alternativeProducts: string[];
  url: string;
  variantOptions: AttributeList[];
  variants: Variant[];
  defaultVariantCode: string;
  attributes: AttributeSet;
  symbols: Attribute[];
  labels: CodeValue[];
  files: Media[];
  videos: Media[];
  categories: number[];
  displayOrders: Map<string, number>;
  storeViews: string[];
  sectors: string[];
  unitOfMeasureCode?: string;
  status: ProductStatus
}

export interface Variant {
  code: string;
  title: string;
  url: string;
  media: Media[];
  optionCode1: string;
  optionCode2: string;
  unitsOfMeasure: UnitOfMeasure[];
}

export interface ProductAndVariant {
  product: Product;
  variant: Variant;
}

export interface UnitOfMeasure {
  code: string;
  name: string;
  description: string;
  visible: boolean;
  itemsPerUnit: number;
  eanCode: string;
  prices: Prices;
}

export interface CodeValue {
  code: string;
  value: string;
  displayOrder?: number;
}

export interface Media {
  type?: string;
  thumbnail?: string;
  description?: string;
  src: string;
  modified?: Date;
  languageCode?: string;
  alt?: string;
  imageData?: {
    height: number;
    width: number;
  };
}


export { AttributeList };
export { Attribute };
export { AttributeSet };
export { Prices };
